import * as React from 'react';
import { ContentView } from '@levelapp/softfabric';
import ToastViewStyle from './ToastViewStyle';
import ToastViewModel from './ToastViewModel';
import { Platform } from 'react-native';
import ToastMobileView from './toastmobile/ToastMobileView';
export default class ToastView extends ContentView {
    /* CONSTRUCTOR */
    constructor(props) {
        super(props);
        // Binding
        this.bind(new ToastViewModel(this), new ToastViewStyle(this));
    }
    /* RENDERING */
    render() {
        if (Platform.OS == "web") {
            var ToastWebView = require('./toastweb/ToastWebView').default;
            return (React.createElement(ToastWebView, Object.assign({}, this.props)));
        }
        return (React.createElement(ToastMobileView, Object.assign({}, this.props, { style: { zIndex: 300 } })));
    }
}
